import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAiChatState } from "../../../aiChat/AiChatContext";
import { usePane } from "./usePane";
import { paneStore } from "../paneStore";
import { foldControlFor } from "../paneRules";
import { usePaneSlots } from "../usePanes";
import { usePaneLayoutStyles } from "./PaneLayout.styles";

/**
 * The buttons every pane ends its header with: fold into or out of the rail (stage panes only) and
 * close. PaneLayout places them at the end of every header.
 */
function PaneLayoutControls() {
    const { translateString } = useTranslation();
    const styles = usePaneLayoutStyles();
    const { slot, isStagePane, requestClose } = usePane();
    const { hasPaneOnRight, hasPaneOnStage } = usePaneSlots();
    const { isOpen: isChatOpen } = useAiChatState();

    const foldControl = foldControlFor({ isStagePane, slot, hasPaneOnRight, hasPaneOnStage, isChatOpen });
    const isInRail = foldControl === "expand";

    return (
        <Box sx={styles.controls}>
            {foldControl && (
                <DotLegalTooltip text={translateString(isInRail ? "expandPanel" : "collapsePanel")}>
                    <IconButton size="small" sx={styles.headerIconButton} onClick={isInRail ? paneStore.expandStage : paneStore.collapseStage}>
                        {isInRail ? <OpenInFullIcon fontSize="small" /> : <CloseFullscreenIcon fontSize="small" />}
                    </IconButton>
                </DotLegalTooltip>
            )}

            <DotLegalTooltip text={translateString("close")}>
                <IconButton size="small" sx={styles.headerIconButton} onClick={requestClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DotLegalTooltip>
        </Box>
    );
}

export default PaneLayoutControls;
